"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUse = require("react-use");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _screenShareView = require("./screenShareView");
var _whiteboard = require("../plugins/whiteboard");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Editor = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var roomId = _ref.roomId;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: {
      mx: "$4",
      flex: "3 1 0",
      "@lg": {
        flex: "2 1 0",
        "& video": {
          objectFit: "contain"
        }
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        position: "relative",
        width: "100%",
        height: "100%"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_whiteboard.Whiteboard, {
        roomId: roomId
      })
    })
  });
});
var WhiteboardView = function WhiteboardView() {
  // for smaller screen we will show sidebar in bottom
  var mediaQueryLg = _reactUi.config.media.lg;
  var showSidebarInBottom = (0, _reactUse.useMedia)(mediaQueryLg);
  var peers = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeers);
  var roomId = (0, _reactSdk.useHMSStore)(_reactSdk.selectRoomID);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      size: "100%"
    },
    direction: showSidebarInBottom ? "column" : "row",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Editor, {
      roomId: roomId
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      direction: {
        "@initial": "column",
        "@lg": "row"
      },
      css: {
        overflow: "hidden",
        p: "$4",
        flex: "0 0 20%",
        "@lg": {
          flex: "1 1 0"
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_screenShareView.SidePane, {
        showSidebarInBottom: showSidebarInBottom,
        isPresenterInSmallTiles: true,
        smallTilePeers: peers,
        totalPeers: peers.length
      })
    })]
  });
};
var _default = WhiteboardView;
exports["default"] = _default;